module.exports = __webpack_public_path__ + "static/media/home-bg-ship.1b10c93f.jpg";